import script from "./PropertyGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyGallery.vue?vue&type=script&setup=true&lang=js"

import "./PropertyGallery.vue?vue&type=style&index=0&id=f10fe4b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f10fe4b4"]])

export default __exports__